<template>
<div id="app">
  <navbar />
  <span id="header"></span>
  <app-header />
  <span id="projs"></span>
  <section-divider>Projects</section-divider>
  <projects />
  <span id="contact"></span>
  <section-divider>Contact Me</section-divider>
  <Modal />
  <Alert />
  <contact />
  <TFooter />
</div>
</template>

<script>
import Navbar from '@/components/Navbar/Navbar';
import AppHeader from '@/components/Header/AppHeader';
import SectionDivider from '@/components/SectionDivider';
import Projects from '@/components/Projects/Projects';
import Modal from '@/components/Modal';
import Alert from '@/components/Alert';
import Contact from '@/components/Contact/Contact';
import TFooter from '@/components/Footer/TFooter';

export default {
  name: 'App',
  components: {
    Navbar,
    AppHeader,
    SectionDivider,
    Projects,
    Modal,
    Alert,
    Contact,
    TFooter,
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400');

* {
  outline: none;
}

body {
  background: $default_bg;
  font-family: 'Roboto', sans-serif;
  &.modal-open {
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue